import React, { useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XTabNav } from '@/components/xqxc_ui.js';
import EvaluationType from './evaluationType';//评价星级
import EvaluationInfo from './evaluationInfo';//评价内容

const EvaluationRule = ({ history }) => {

    const [activedID, setActivedID] = useState(1);

    const tabs = [{
        id: 1,
        label: '评价星级'
    }, {
        id: 2,
        label: '评价内容'
    }];

    return <div className={styles.container}>
        <XTabNav
            activedID={activedID}
            renderData={tabs}
            onChange={id => setActivedID(id)}
        />
        <div className={styles.pageContent}>
            {
                activedID == 1 ?
                    <EvaluationType history={history} /> :
                    <EvaluationInfo history={history} />
            }
        </div>
    </div>;
};

EvaluationRule.propTypes = {
    history: PropTypes.object.isRequired,//路由对象
};
export default EvaluationRule;